const careOrderStatusReasonType = {
	InReview: 1,
	ManuallyBooked: 3,
	PatientDeceased: 4,
	Created: 5,
	FollowUpNoLongerNeeded: 6,
	PatientSelfScheduled: 7
};

export default careOrderStatusReasonType;